import { useFeatureListeners } from "./useFeatureListeners";
import { useToolListeners } from "./useToolListeners";

export { useFeatureListeners, useToolListeners };

export function useAllListeners() {
	useToolListeners();
	useFeatureListeners();
}
